/**
 * @generated SignedSource<<75da5d2be5ce1e9cf7eeac5d96fef423>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerFormField_field",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "answer",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AnswerPreview_answer"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerFormField",
  "abstractKey": null
};

node.hash = "5b30fc618acca0ea4f4cae172a2f66d5";

module.exports = node;
